import { CashSession } from '@/@types/cash-management';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { CashSessionStatusLabel } from './CashSessionStatusLabel';
import { formatCurrency } from './cash-management.utils';
import {
  CashSessionsTableActions,
  CashSessionsTableActionsProps,
} from './CashSessionsTableActions';

export type CashSessionTableActions = {
  // eslint-disable-next-line no-unused-vars
  onViewCashSession: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onStartReconciliation: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditDeclarations: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onCloseCashSession: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRevertCashSession: (id: string) => void;
};

type CashSessionTableRow = CashSession & Partial<CashSessionTableActions>;

export const CashSessionsTableColumns: ColumnDefinitionType<CashSessionTableRow>[] =
  [
    { key: 'number', header: 'Número', sort: 'number' },
    {
      key: 'user',
      header: 'Usuário',
      render: ({ user }) => user?.name || '',
      sort: 'user.name',
    },
    { key: 'openedAt', header: 'Aberto em', sort: 'opened_at' },
    {
      key: 'reconciliationStartedAt',
      header: 'Conferência em',
      sort: 'reconciliation_started_at',
    },
    { key: 'closedAt', header: 'Fechado em', sort: 'closed_at' },
    {
      key: 'status',
      header: 'Status',
      render: ({ status }) => <CashSessionStatusLabel status={status} />,
      sort: 'status',
    },
    {
      key: 'startingCash',
      header: 'Saldo Inicial',
      render: ({ startingCash }) => formatCurrency(startingCash),
      align: 'right',
      sort: 'starting_cash',
    },
    {
      key: 'expectedCash',
      header: 'Saldo Previsto',
      render: ({ expectedCash }) => formatCurrency(expectedCash),
      align: 'right',
      sort: 'expected_cash',
    },
    {
      key: 'declaredCash',
      header: 'Saldo Final',
      render: ({ declaredCash }) => formatCurrency(declaredCash),
      align: 'right',
      sort: 'declared_cash',
    },
    {
      key: 'discrepancy',
      header: 'Diferença',
      render: ({ discrepancy }) => formatCurrency(discrepancy),
      align: 'right',
      sort: 'discrepancy',
    },
    { key: 'createdAt', header: 'Criado em', sort: 'created_at' },
    {
      key: 'id',
      header: 'Ações',
      render: (cashSession) => (
        <CashSessionsTableActions
          {...(cashSession as CashSessionsTableActionsProps)}
        />
      ),
      width: '8rem',
      align: 'center',
      sticky: 'right',
    },
  ];
